import { Area } from '@src/main/modules/common/area/domain/Area';
import { AreaRepository } from '@src/main/modules/common/area/domain/AreaRepository';

export const findAllAreas = async (repository: AreaRepository): Promise<Area[]> =>
  await repository.findAll();
